import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, switchMap, catchError, EMPTY } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  private currentBuildTimestamp: string | null = null;
  private readonly POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
  private toastActive = false;

  constructor(private http: HttpClient, private toastr: ToastrService) {}

  startPolling(): void {
    this.fetchVersion().subscribe(v => {
      this.currentBuildTimestamp = v.buildTimestamp;
    });

    interval(this.POLL_INTERVAL_MS)
      .pipe(switchMap(() => this.fetchVersion()))
      .subscribe(v => {
        if (this.currentBuildTimestamp && v.buildTimestamp !== this.currentBuildTimestamp) {
          this.showUpdateToast();
        }
      });
  }

  private fetchVersion() {
    return this.http
      .get<{ buildTimestamp: string }>(environment.currentVersion, {
        headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
      })
      .pipe(catchError(() => EMPTY));
  }

  private showUpdateToast(): void {
    if (this.toastActive) return;
    this.toastActive = true;
    const toast = this.toastr.info(
      'Klicken Sie hier, um die Seite neu zu laden.',
      'Neue Version verfügbar',
      { disableTimeOut: true, closeButton: true, tapToDismiss: false }
    );
    toast.onTap.subscribe(() => window.location.reload());
    toast.onHidden.subscribe(() => (this.toastActive = false));
  }
}
